import type { Editor } from "@tiptap/core";

/** Non-overlapping, case-insensitive occurrence count in plain text. */
export function countPlainOccurrences(plain: string, query: string): number {
  const q = query.trim().toLowerCase();
  if (!q) return 0;
  const lower = plain.toLowerCase();
  let n = 0;
  let start = 0;
  while (true) {
    const at = lower.indexOf(q, start);
    if (at < 0) break;
    n += 1;
    start = at + q.length;
  }
  return n;
}

/**
 * Select the Nth (0-based) case-insensitive occurrence of `query` in the
 * editor by walking concatenated text nodes.
 */
export function selectQueryOccurrence(
  editor: Editor,
  query: string,
  occurrence: number,
): boolean {
  const q = query.trim();
  if (!q || occurrence < 0 || editor.isDestroyed) return false;
  const qLower = q.toLowerCase();

  let haystack = "";
  const indexToPos: number[] = [];
  editor.state.doc.descendants((node, pos) => {
    if (!node.isText || !node.text) return;
    for (let i = 0; i < node.text.length; i++) {
      indexToPos.push(pos + i);
      haystack += node.text[i]!;
    }
  });

  const lower = haystack.toLowerCase();
  let found = -1;
  let start = 0;
  while (true) {
    const at = lower.indexOf(qLower, start);
    if (at < 0) return false;
    found += 1;
    if (found === occurrence) {
      const from = indexToPos[at];
      const lastChar = indexToPos[at + q.length - 1];
      if (from === undefined || lastChar === undefined) return false;
      const to = lastChar + 1;
      editor
        .chain()
        .focus(undefined, { scrollIntoView: true })
        .setTextSelection({ from, to })
        .run();
      return true;
    }
    start = at + q.length;
  }
}
